import React, { useEffect, useState } from "react";
import {
  Button,
  ConfigProvider,
  Modal,
  Pagination,
  Space,
  Tag,
  Typography,
} from "antd";
import { Link, useLocation } from "wouter";
import { EyeFilled } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import {
  SubOrdersListAPI,
  SubOrdersListDealerAPI,
} from "../../../../redux/actions/adminActions/listsAction";
import { FetchSubOrderItemsAPI } from "../../../../redux/actions/adminActions/subOrdersAction";
import Alertify from "../../../../services/alertify";
import CommonAdminTable from "../../../components/commonTable";
import { getQueryParams } from "../../../../utilities/getQueryParams";
import { useLoader } from "../../../../utilities/useLoader";
import { ReloadOutlined } from "@ant-design/icons";
import { RefreshSubOrderItemsAPI } from "../../../../redux/actions/adminActions/orderRefreshAction";
import { OrdersErrorAPI } from "../../../../redux/actions/adminActions/orderDetailsAction";
import { LoaderIcon } from "react-hot-toast";
import { ADMIN } from "../../../../redux/constants/roles";

const { Title } = Typography;

const SubOrdersList = () => {
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const orderId = params.orderId;
  const ifDealer = params?.dealer;
  const initialPage = params.page || 1;

  const [currentPage, setCurrentPage] = useState(initialPage);
  const [totalOrders, setTotalOrders] = useState(0);
  const [allSubOrders, setAllSubOrders] = useState([]);
  const dispatch = useDispatch();
  const [loader, startLoader, endLoader] = useLoader();
  const [refreshloader, startRefreshLoader, endRefreshLoader] = useLoader();

  useEffect(() => {
    document.title = "Orders: ALP Shop";
  }, []);
  useEffect(() => {
    const data = {
      currentPage: currentPage,
      perPage: 10,
      order_id: orderId,
    };
    if (orderId && !ifDealer) {
      dispatch(SubOrdersListAPI(data))
        .then((response) => {
          if (
            response.payload &&
            response.payload.data &&
            response.payload.data.data
          ) {
            const subOrdersWithIndex = response.payload.data.data.map(
              (product, index) => ({
                ...product,
                key: product.sub_order_id || index,
                index: index + 1 + (currentPage - 1) * 10,
              }),
            );
            setAllSubOrders(subOrdersWithIndex);
            const total = response.payload.data.pagination.total || 0;
            setTotalOrders(total);
            // console.log("All Sub Orders are:+++", subOrdersWithIndex);
          } else {
            throw new Error("Unexpected API response structure");
          }
        })
        .catch((error) => {
          Alertify.error(
            "Failed to fetch the all products list: " + error.message,
          );
        });
    } else if (ifDealer && orderId) {
      dispatch(SubOrdersListDealerAPI(data))
        .then((response) => {
          if (
            response.payload &&
            response.payload.data &&
            response.payload.data.data
          ) {
            const subOrdersWithIndex = response.payload.data.data.map(
              (product, index) => ({
                ...product,
                key: product.sub_order_id || index,
                index: index + 1 + (currentPage - 1) * 10,
              }),
            );
            setAllSubOrders(subOrdersWithIndex);
            const total = response.payload.data.pagination.total || 0;
            setTotalOrders(total);
            // console.log("All Sub Orders are:+++", subOrdersWithIndex);
          } else {
            throw new Error("Unexpected API response structure");
          }
        })
        .catch((error) => {
          Alertify.error(
            "Failed to fetch the all products list: " + error.message,
          );
        });
    }
  }, [currentPage, dispatch, orderId]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/orders/sub-order-list?orderId=${orderId}&page=${page}`);
  };
  const handleSubOrderCreate = () => {
    try {
      const data = {
        order_id: orderId,
      };
      startLoader();
      // console.log(loader);
      dispatch(FetchSubOrderItemsAPI(data))
        .unwrap()
        .then((fetchedData) => {
          navigate(`/admin/orders/create-new-order?orderId=${orderId}`);
        })
        .catch((error) => {
          // console.log(loader);
          endLoader();
          console.error("Error fetching Sub Order Items:", error);
          Alertify.error(`${error.message}`);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const [errorModal, setErrorModal] = useState(false);
  const [activeOrderId, setActiveOrderId] = useState("");
  const [errors, setErrors] = useState("");
  const [loader1, setLoader1] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  const authData = useSelector((state) => state.auth_store);

  useEffect(() => {
    if (authData.role === ADMIN) {
      setIsAdmin(true);
    }
  }, [setIsAdmin, authData.role]);
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      align: "center",
    },
    {
      title: "Sub Order ID",
      dataIndex: "sub_order_id",
      key: "sub_order_id",
    },
    ...(!ifDealer
      ? [
          {
            title: "Sell to Customer No.",
            dataIndex: "sell_to_customer_no",
            key: "sell_to_customer_no",
          },
          {
            title: "Order Value",
            dataIndex: "order_value",
            key: "order_value",
          },
        ]
      : []),
    {
      title: "Order Status",
      key: "status",
      dataIndex: "delivery_status",
      render: (status, record) => {
        let color =
          status === "approved"
            ? "green"
            : status === "error"
              ? "red"
              : "geekblue";
        return (
          <Tag
            color={color}
            key={status}
            className="font-bold"
            style={{ cursor: status === "Error" ? "pointer" : "default" }}
          >
            {status ===
            (
              <p
                onClick={() => {
                  setErrorModal(true);
                  setActiveOrderId(record.orderId);
                  // console.log("Active record:", record.orderId);
                  const data = {
                    order_id: record.orderId,
                  };
                  setLoader1(true);
                  dispatch(OrdersErrorAPI(data))
                    .then((response) => {
                      setErrors(response.payload.data.data);
                      setLoader1(false);
                      // console.log("Errors--=-=-=-=-=-=-=-=-=-=-:", response);
                    })
                    .catch((error) => {
                      Alertify.error(
                        "Failed to get Orders' erros:",
                        error.message,
                      );
                    });
                  // console.log("Errors--=-=-=-=-=-=-=-=-=-=-:", errors);
                }}
              >
                FAILED
              </p>
            )
              ? "FAILED"
              : status.toUpperCase()}
          </Tag>
        );
      },
    },
    {
      title: "Placed At",
      dataIndex: "placed_at",
      key: "placed_at",
    },
    ...(!isAdmin
      ? [
          {
            title: "Action",
            key: "action",
            align: "center",
            render: (record) => (
              <Space size="middle">
                {!ifDealer && (
                  <Link
                    to={`/admin/orders/sub-order-details?subOrderId=${record.sub_order_id}`}
                    className="text-red-600"
                  >
                    <EyeFilled className="me-2" />
                    View
                  </Link>
                )}
                {ifDealer && record?.delivery_status !== "approved" && (
                  <Link
                    to={`/admin/orders/create-new-order?orderId=${orderId}&by_dealer=true&dealer_sub_order_id=${record.sub_order_id}`}
                    className="text-red-600"
                  >
                    <EyeFilled className="me-2" />
                    Edit
                  </Link>
                )}
              </Space>
            ),
          },
        ]
      : []),
  ];
  const handleRefresh = () => {
    startRefreshLoader();
    let orderData = {
      order_id: orderId,
    };
    dispatch(RefreshSubOrderItemsAPI(orderData))
      .unwrap()
      .then((response) => {
        if (response?.data.status === "success" && response.status === 200) {
          const data = {
            currentPage: currentPage,
            perPage: 10,
            order_id: orderId,
          };
          dispatch(SubOrdersListAPI(data))
            .then((response) => {
              if (
                response.payload &&
                response.payload.data &&
                response.payload.data.data
              ) {
                const subOrdersWithIndex = response.payload.data.data.map(
                  (product, index) => ({
                    ...product,
                    key: product.sub_order_id || index,
                    index: index + 1 + (currentPage - 1) * 10,
                  }),
                );
                setAllSubOrders(subOrdersWithIndex);
                const total = response.payload.data.pagination.total || 0;
                setTotalOrders(total);
                // console.log("All Sub Orders are:+++", subOrdersWithIndex);
                endRefreshLoader();
              } else {
                endRefreshLoader();

                throw new Error("Unexpected API response structure");
              }
            })
            .catch((error) => {
              endRefreshLoader();

              Alertify.error(
                "Failed to fetch the all products list: " + error.message,
              );
            });
        }
      })
      .catch((error) => {
        endRefreshLoader();

        Alertify.error(
          "Failed to fetch Order Request List: " +
            (error?.message || "Unknown error"),
        );
      });
  };
  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Typography: {
              titleMarginBottom: 0,
              titleMarginTop: 0,
            },
          },
        }}
      >
        <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
          <div className="sm:w-2/3">
            <Title level={2} className="text-left p-0 m-0">
              {orderId}
              {ifDealer && " (Dealer Sub Orders)"}
            </Title>
          </div>
          {/* <Link to={`/admin/orders/create-new-order?orderId=${orderId}`}> */}
          <div className="flex justify-end items-center gap-2">
            {!isAdmin && (
              <Button
                type="primary"
                className="rounded-md"
                onClick={handleSubOrderCreate}
                loading={loader}
              >
                Create New Sub Order+
              </Button>
            )}
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              className="flex items-center rounded-md ml-2"
              loading={refreshloader}
            >
              Refresh
            </Button>
          </div>
          {/* </Link> */}
        </div>
      </ConfigProvider>
      <CommonAdminTable columns={columns} data={allSubOrders} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalOrders}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
      <Modal
        open={errorModal}
        onCancel={() => setErrorModal(false)}
        footer={false}
        centered
        className="rounded-lg border-2"
      >
        <div className="flex items-center gap-16">
          <h1 className="mb-0 font-bold text-[2rem]">{activeOrderId}</h1>
          <span className="text-[#CD4444] font-medium bg-[#FFEBEB] px-4 py-1 rounded-md">
            Failed
          </span>
        </div>
        <div className="bg-[#F3F8FC] p-4 rounded-md">
          {!loader1 ? (
            <>
              {errors.map((item, index) => (
                <div key={index} className="border-b-2 p-2 border-gray-400">
                  <p className="font-semibold">Error Message {index + 1}</p>
                  <p>{item.Error_Message}</p>
                </div>
              ))}
            </>
          ) : (
            <LoaderIcon />
          )}
        </div>
      </Modal>
    </>
  );
};

export default SubOrdersList;
